import { combineReducers } from '@reduxjs/toolkit';

import { i18nReducer } from 'react-redux-i18n';
import { customers } from 'store/customers/customers.reducer';
import { manualActions } from 'store/manualActions/manualActions.reducer';
import { metadata } from 'store/metadata/metadata.reducer';
import { orderEdition } from 'store/orderEdition/orderEdition.reducer';
import { orders } from 'store/orders/orders.reducer';
import { punchOrderFlow } from 'store/punchOrderFlow/punchOrderFlow.reducer';
import { punchOrderFlowDiscounts } from 'store/punchOrderFlowDiscounts/punchOrderFlowDiscounts.reducer';
import { punchOrderFlowNext } from 'store/punchOrderFlowNext/punchOrderFlow.reducer';
import { settings } from 'store/settings/settings.reducer';
import { wallets } from 'store/wallets/wallets.reducer';

export const rootReducer = combineReducers({
  i18n: i18nReducer,
  metadata,
  punchOrderFlow,
  punchOrderFlowNext,
  punchOrderFlowDiscounts,
  orders,
  manualActions,
  settings,
  orderEdition,
  wallets,
  customers,
});
